import React, { useState, useEffect } from "react";
import Layout from "../../../../components/AdminLayout";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const EditHomeBanner = () => {
  const { id } = useParams();
  const [homeBanner, setHomeBanner] = useState(null);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
const [validationError, setValidationError] = useState("");
  const [totalHomeBanners, setTotalHomBanners] = useState(0);
  
  const [formData, setFormData] = useState({
    alt: "",
    heading: "",
    banner: {
      file: "",
      filepath: "",
    },
    heading_color: "",
    button: "",
    button_url: "",
    sequence: ""
  });

  useEffect(() => {
    const fetchHomeBanner = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await axios.get(`${apiUrl}/api/home-banner/${id}`);
        const homeBannerData = response.data.banner;
        setHomeBanner(homeBannerData);

        setFormData({
          alt: homeBannerData.alt || "",
          heading: homeBannerData.heading || "",
          heading_color: homeBannerData.heading_color || "",
          button: homeBannerData.button || "",
          button_url: homeBannerData.button_url || "",
          banner: {
            file: homeBannerData.banner.filename,
            filepath: homeBannerData.banner.filepath || "",
          },
          type: homeBannerData.type,
          sequence: homeBannerData.sequence
        });

        const totalHomeBanners = await axios.get(
          `${apiUrl}/api/home-banner`
        );
        const totalCount = totalHomeBanners.data.count;
        setTotalHomBanners(totalCount);
                console.log("Count", totalCount);
                
      } catch (error) {
        console.error("Error fetching home banner:", error);
        setErrorMessage("Failed to fetch home banner data.");
      }
    };

    fetchHomeBanner();
  }, [id]);

   const handleChange = (e) => {
    setErrorMessage("")
    setValidationError("")

    const { name, value, files } = e.target;

    if (name === "banner" && files?.length > 0) {
    const file = files[0];
    const ext = file.name.split(".").pop().toLowerCase();
    const isImage = ["webp", "jpg", "jpeg", "png"].includes(ext);
    const isVideo = ["mp4"].includes(ext);

    setFormData((prev) => ({
      ...prev,
      type: isImage ? "image" : "video", // 👈 update type when new file chosen
      banner: {
        file,
        filepath: URL.createObjectURL(file),
      },
    }));
  } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value.trim() === "" ? "" : value,
      }));
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

     if (validationError) {
        toast.error(validationError);
        return;
    }

     if (errorMessage) {
        toast.error(errorMessage);
        return;
    }

    setIsSubmitting(true);

    setErrorMessage("");

     if (formData.sequence > totalHomeBanners) {
      setErrorMessage(
        `Total entries are ${totalHomeBanners}. Sequence cannot be greater than ${totalHomeBanners}`
      );
      return;
    }

    const isImage = formData.type === "image";
  const isVideo = formData.type === "video";

  if (isImage && formData.alt.trim() === "") {
    setValidationError("Alt text is required for images.");
    setIsSubmitting(false);
    return;
  }

    const formDataToSend = new FormData();

    formDataToSend.append("heading", formData.heading || "");
    formDataToSend.append("heading_color", formData.heading_color || "");
    formDataToSend.append("button", formData.button || "");
    formDataToSend.append("button_url", formData.button_url || "");
      formDataToSend.append("sequence", Number(formData.sequence) || "");

    if (formData.banner.file instanceof File) {
    formDataToSend.append("banner", formData.banner.file);
  }
  
  if (isImage) {
    formDataToSend.append("alt", formData.alt);
  } else if (isVideo) {
    formDataToSend.append("alt", "");
  }
    try {
      const access_token = localStorage.getItem("access_token");
      const apiUrl = process.env.REACT_APP_API_URL;

      const response = await axios.patch(
        `${apiUrl}/api/home-banner/${id}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      console.log("Updated home banner:", response.data.updatedBanner);
      navigate("/admin/home-banner");
              toast.success("Home banner updated successfully!");

    } catch (error) {
      console.error("Error updating home banner:", error);
              toast.error("Failed to update home banner");

      setErrorMessage(error.response?.data?.message || "An error occurred");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Layout>
      <div className="theme-form-header">
        <h2>Edit Home Banner</h2>
      </div>
      <div className="form-white-bg">
        <form onSubmit={handleSubmit}>
          <div className="row">
            
           <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="theme-form">
                <label>Banner (Image OR Video)</label>
               <input
                 type="file"
                 name="banner"
                 accept=".webp,.jpg,.jpeg,.png,.mp4"
                 onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    const ext = file.name.split(".").pop().toLowerCase();
                    const isImage = ["webp", "jpg", "jpeg", "png"].includes(ext);
                    const isVideo = ext === "mp4";

                    let maxSizeBytes = 0;

                    if (isImage) maxSizeBytes = 500 * 1024; // 500 KB
                    else if (isVideo) maxSizeBytes = 10 * 1024 * 1024; // 10 MB
                    else {
                      setErrorMessage("Only images or MP4 videos are allowed.");
                      e.target.value = "";
                      return;
                    }

                    if (file.size > maxSizeBytes) {
                      setErrorMessage(
                        isImage
                          ? "Image size must be under 500 KB."
                          : "Video size must be under 10 MB."
                      );
                      e.target.value = "";
                      return;
                    }

                    // Clear any previous error
                    setErrorMessage("");

                    setFormData((prev) => ({
                      ...prev,
                      type: isImage ? "image" : "video",
                      banner: {
                        file,
                        filepath: URL.createObjectURL(file),
                      },
                    }));
                  }}
               />
                {formData.type === "image" ? (
                  <img
                    className="form-profile"
                    src={`${formData.banner.filepath}`}
                    alt={`${formData.alt}`}
                    loading="lazy"
                  />
                ) : (
                  <video
                    className="form-profile"
                    src={`${formData.banner.filepath}`}
                    style={{ width: "100px", height: "100px" }}
                    autoPlay
                    muted
                    loop
                    playsInline
                  />
                )}
              </div>
            </div>

            {(formData.type === "image") && (
              <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="theme-form">
                  <label>Alt</label>
                  <input
                    type="text"
                    name="alt"
                    required
                    value={formData.alt}
                    onChange={handleChange}
                  />
                </div>
              </div>
            )}

            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="theme-form">
                <label>Heading</label>
                <input
                  type="text"
                  name="heading"
                  required
                  value={formData.heading}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="theme-form">
                <label>Heading Color</label>
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="color"
                    style={{ height: "40px", width: "120px" }}
                    name="heading_color"
                    value={formData.heading_color}
                    onChange={handleChange}
                  />
                  <input
                    type="text"
                    maxLength={7}
                    placeholder="#FFFFFF"
                    value={formData.heading_color}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="theme-form">
                <label>Button</label>
                <input
                  type="text"
                  name="button"
                  value={formData.button}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="theme-form">
                <label>Button Url</label>
                <input
                  type="text"
                  name="button_url"
                  value={formData.button_url}
                  onChange={handleChange}
                />
              </div>
            </div>
  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="theme-form">
                <label>Sequence</label>
                <input
                  type="text"
                  name="sequence"
                  value={formData.sequence}
                  required
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              {errorMessage && (
                <div className="error-message text-danger">{errorMessage}</div>
              )}
            </div>

            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              {validationError && (
                <div className="validation-message text-danger">{validationError}</div>
              )}
            </div>

            <div className="col-12">
              <div className="theme-form">
                <button type="submit" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <div className="d-flex align-items-center">
                      <span
                        className="spinner-border me-2"
                        role="status"
                      ></span>
                      Save
                    </div>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Layout>
  );
};

export default EditHomeBanner;
